export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_04-01d29fafca3bbacf6b53c79e5b457ad7.jpg";